import React from "react";
import {isEmpty} from "lodash";
import {Card, Form, Row, Col, UncontrolledTooltip} from "reactstrap";
import {IoMdCloseCircleOutline} from "react-icons/io";
import InputCreator from "../../../components/Forms/components/InputCreator";
import Button from "../../../components/Button";
import {toast} from "react-toastify";
import {useDispatch, useSelector} from "react-redux";
import {
  storeCreateNonTestData,
  setNonTestFormVisibility,
  createNonTestTemplate,
} from "../../../redux/Actions/reports.actions";
import {getCreateNonTestData} from "../../../redux/Selectors/reports.selectors";

const NonTestForm = () => {
  const dispatch = useDispatch();
  const createNonTestData = useSelector(getCreateNonTestData);

  const {
    description = "",
    units = "",
    op_low = "",
    op_high = "",
    id = "",
  } = createNonTestData;

  const onChangeHandler = (e) => {
    let updateObj = {...createNonTestData};
    updateObj = Object.assign({}, updateObj, {
      [e.target.name]: e.target.value,
    });
    dispatch(storeCreateNonTestData(updateObj));
  };

  const closeNonTestForm = () => {
    dispatch(storeCreateNonTestData({}));
    dispatch(setNonTestFormVisibility(false));
  };

  const addNonTestTemplate = () => {
    if (
      !isEmpty(description.toString()) &&
      !isEmpty(units.toString()) &&
      !isEmpty(op_low.toString()) &&
      !isEmpty(op_high.toString())
    ) {
      const payload = {...createNonTestData};
      dispatch(createNonTestTemplate(payload, closeNonTestForm));
    } else {
      toast.error("Please check required fields");
    }
  };

  return (
    <Card
      style={{
        padding: "1rem 0px",
        boxShadow: "0px 3px 6px #00000029",
        position: "relative",
      }}
    >
      <div
        className="roboto-bold"
        style={{
          fontSize: "16px",
          fontWeight: "bold",
          borderBottom: "1px solid #20C1FF",
          margin: "0px 1rem 1rem 1rem",
          color: "#303030",
          paddingBottom: "5px",
        }}
      >
        {id ? "Edit Manual Result" : "Add Manual Result"}
      </div>
      <span
        style={{
          position: "absolute",
          top: "1rem",
          right: "1rem",
          fontSize: "20px",
          cursor: "pointer",
        }}
      >
        <IoMdCloseCircleOutline
          id="non-test-form-close-button"
          onClick={closeNonTestForm}
        />
      </span>
      {document.getElementById("non-test-form-close-button") && (
        <span>
          <UncontrolledTooltip target="non-test-form-close-button" placement={"top"}>
            Close
          </UncontrolledTooltip>
        </span>
      )}

      <Form>
        <Row>
          <Col lg={6}>
            <InputCreator
              large
              label={"Description"}
              isRequired
              onChange={onChangeHandler}
              name={"description"}
              value={description}
              placeholder="Add Your Description"
              style={{
                border: "1px solid #d6d6d6",
                maxHeight: "38px",
                boxShadow: "none",
              }}
              data-cy="manualResultDesc"
            />
          </Col>
          <Col lg={6}>
            <InputCreator
              large
              label={"Units"}
              isRequired
              onChange={onChangeHandler}
              name={"units"}
              value={units}
              placeholder="Enter Units"
              style={{
                border: "1px solid #d6d6d6",
                maxHeight: "38px",
                boxShadow: "none",
              }}
              data-cy="manualResultUnit"
            />
          </Col>
          <Col lg={6}>
            <InputCreator
              large
              type="number"
              label={"Operation Low"}
              onChange={onChangeHandler}
              name={"op_low"}
              value={op_low}
              placeholder="Enter value"
              isRequired
              style={{
                border: "1px solid #d6d6d6",
                maxHeight: "38px",
                boxShadow: "none",
              }}
              data-cy="manualResultOpLow"
            />
          </Col>
          <Col lg={6}>
            <InputCreator
              large
              type="number"
              label={"Operation High"}
              onChange={onChangeHandler}
              name={"op_high"}
              value={op_high}
              placeholder="Enter value"
              isRequired
              style={{
                border: "1px solid #d6d6d6",
                maxHeight: "38px",
                boxShadow: "none",
              }}
              data-cy="manualResultOpHigh"
            />
          </Col>
        </Row>
        <div className="d-flex justify-content-end" style={{marginRight: "1rem"}}>
          <Button withRadius onClick={addNonTestTemplate} data-cy="createManualResult">
            {id ? "SAVE" : "ADD"}
          </Button>
        </div>
      </Form>
    </Card>
  );
};

export default NonTestForm;
